// api.js (assuming you already have api and auth imported)
import api from "./api";
import auth from "./auth";

export default {


    getMerchantSetup() {
        return new Promise((resolve, reject) => {
            api.get("/merchant-service/merchant/setup", auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, errors) => {
                    reject(status, errors);
                });
        });
    },
    getProvinces() {
        return new Promise((resolve, reject) => {
            api.get(
                "/organization-service/api/cms/provinces",
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, errors) => {
                    reject(status, errors);
                });
        });
    },
    getCities(province) {
        return new Promise((resolve, reject) => {
            api.post(
                "/organization-service/api/cms/cities",
                { "province": province},
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, errors) => {
                    reject(status, errors);
                });
        });
    },
    getBranchList() {
        return new Promise((resolve, reject) => {
            api.get(
                '/organization-service/v2/branch/list',
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, errors) => {
                    reject(status, errors);
                });
        });
       
    },
    updateBranch(uuid, params) {
        return new Promise((resolve, reject) => {
            api.post(
                `/organization-service/v2/branch/update/${uuid}`,
                params,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, errors) => {
                    reject(status, errors);
                });
        });
    },

    getProductList(page) {
        return new Promise((resolve, reject) => {
            api.get(
                `/estore-service/v1/cms/estore/product/inventory/list/${page}`,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, errors) => {
                    reject(status, errors);
                });
        });
    },
    getWebList() {
        return new Promise((resolve, reject) => {
            api.get(
               '/design-service/web/list',
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, errors) => {
                    reject(status, errors);
                });
        });

    },
    getFulfillment() {
        return new Promise((resolve, reject) => {
            api.get(
                '/organization-service/v2/api/cms/fulfillment/setup/list',
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, errors) => {
                    reject(status, errors);
                });
        });

    },
    updateFulfillment(payload) {
        return new Promise((resolve, reject) => {
            api.post(
                '/organization-service/v2/api/cms/fulfillment/setup/update',
                payload,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, errors) => {
                    reject(status, errors);
                });
        });

    },
    getFulfillmentFees() {
        return new Promise((resolve, reject) => {
            api.get(
                '/organization-service/api/cms/fulfillment-fees-settings',
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, errors) => {
                    reject(status, errors);
                });
        });

    },
    saveFulfillmentFeesSettings(payload) {
        return new Promise((resolve, reject) => {
            api.post(
                '/organization-service/v2/api/cms/fulfillment-fees-settings/save',
                payload,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, errors) => {
                    reject(status, errors);
                });
        });
    },
    getPayoutDetails() {
        return new Promise((resolve, reject) => {
            api.get(
                '/merchant-service/v1/merchant/cms/bank-details/view',
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, errors) => {
                    reject(status, errors);
                });
        });
    },
    updatePayoutDetails(payload) {
        return new Promise((resolve, reject) => {
            api.post(
                '/merchant-service/v2/api/cms/bank-details/save',
                payload,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, errors) => {
                    reject(status, errors);
                });
        });
    },
    getFulfillmentSetupList() {
        return new Promise((resolve, reject) => {
            api.get(
                '/organization-service/v2/api/cms/fulfillment/setup/list',
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, errors) => {
                    reject(status, errors);
                });
        });

    },
    goLiveWebsite() {
        return new Promise((resolve, reject) => {
                api.post("/merchant-service/merchant/setup/golive", null,  auth.getHeader())
                    .then(response => {
                        return resolve(response);
                    })
                    .catch((status, errors) => {
                        reject(status, errors);
                    });
        });
    },
    saveMerchantSetup(payload) {
        return new Promise((resolve, reject) => {
                api.post("/merchant-service/merchant/setup/save", payload,  auth.getHeader())
                    .then(response => {
                        return resolve(response);
                    })
                    .catch((status, errors) => {
                        reject(status, errors);
                    });
        });
    }
};
